<template>
<div id="in_az_app">
    <div class="header">
        <div class="header-text"><h3>AquaZorro</h3></div>
        <div>
            <span class="button-block">
            <router-link :to="{ name: 'aquazor-users'}" data-toggle="tooltip" title="Список пользователей">
                <div class="icon list-icon"></div>
            </router-link>
            <router-link :to="{ name: 'user-cabinet'}" data-toggle="tooltip" title="Настройки пользователя">
                <div class="icon security-agent"></div>
            </router-link>
            <a class="logout" @click="logout" data-toggle="tooltip" title="Выход">
            <div></div>
            </a>
        </span>
        </div>
    </div>
    <div class="content-block">
        <admin-menu-component :page="page_name"></admin-menu-component>
        <router-view></router-view>
    </div>
</div>
</template>

<script>
import '@/assets/css/main.css'
import '@/assets/css/inmain.css'
import '@/assets/css/icons.css'
import auth from '@/auth.js'
import {
    store
} from '@/store'
import AdminMenu from '@/components/elements/admin_menu.vue'

export default {
    created() {
        this.page_name = this.$route.name
        var html_elements = document.getElementsByTagName('html');
        for (var i = 0; i < html_elements.length; i++) {
            html_elements[i].className = "in_main";
        }
    },
    data() {
        return {
            to_groups_list: true,
            page_name: ''
        }
    },
    methods: {
        logout() {
            auth.logout((result) => {
                if (result) {
                    this.$router.replace('/')
                }
            })
        }
    },
    components: {
        'admin-menu-component': AdminMenu
    },
    beforeUpdate() {
        this.page_name = this.$route.name
    },
}
</script>



// WEBPACK FOOTER //
// src/layouts/AppLayout.vue